import { createContext } from "react";
import { DesignStateType } from "../../types";

export type StudioContextType = {
  designState: DesignStateType;
  productName: string;
  designId: string;
  projectId: string;
  projectName?: string;
  isDesignLocked?: boolean;
  teamId?: string;
  isLoading?: boolean;
  editorConfig?: {
    toolbar: {
      breadcrumbs: {
        backPageRoute: string;
        backPageLabel: string;
        backPageTooltip: string;
      };
      hideDesignMenu?: boolean;
      hideMiddleSection?: boolean;
      hideInviteUserButton?: boolean;
      hideCurrentUsers?: boolean;
      hideAddToCartButton?: boolean;
      hideDesignSelector?: boolean;
    };
    redirectToEditorOnDuplicate?: boolean;
  };
};

export const StudioContext = createContext<StudioContextType>({
  // so that the type is never null or undefined, it facilitate the coding process,
  // and it make sense since a skeleton will be show as long as the designState is not defined in StudioContainer
  designState: null as any,
  productName: "",
  designId: "",
  projectId: "",
  projectName: "",
  isDesignLocked: false,
});
